// public/scripts/register-applicant.js
import { http } from "./api/http.js";
import { showSpinner, hideSpinner } from "../app/components/spinner.js";
import { showSuccess, showError } from "../app/components/toast.js";

console.log("[register-applicant] script loaded");

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initApplicantForm);
} else {
	initApplicantForm();
}

function initApplicantForm() {
	console.log("[register-applicant] Initializing form...");

	const form = document.getElementById("applicantForm");
	const errorsEl = document.getElementById("formErrors");

	if (!form) {
		console.warn("⚠️ applicantForm not found in DOM");
		return;
	}

	const submitBtn = form.querySelector("button[type='submit']") || form.querySelector("button");
	if (!submitBtn) {
		console.warn("⚠️ Submit button not found");
	}

	console.log("✅ Applicant form ready and handler attached");

	function setErrors(messages = []) {
		if (!errorsEl) return;
		errorsEl.innerHTML = messages.map((msg) => `<div>- ${msg}</div>`).join("");
	}

	form.addEventListener("submit", async (e) => {
		e.preventDefault();
		e.stopPropagation();

		const fullName = form.fullName.value.trim();
		const email = form.email.value.trim();
		const phone = form.phone.value.trim();
		const skills = form.skills?.value?.trim() || "";
		const password = form.password.value;
		const confirmPassword = form.confirmPassword.value;

		const errors = [];
		if (fullName.length < 2) errors.push("Full name must be at least 2 characters long.");
		if (!/^\S+@\S+\.\S+$/.test(email)) errors.push("Please enter a valid email address.");
		if (!/^[0-9]{10,15}$/.test(phone)) errors.push("Phone number must contain 10–15 digits.");
		if (password.length < 6) errors.push("Password must be at least 6 characters long.");
		if (!confirmPassword) errors.push("Confirm password is required.");
		if (password !== confirmPassword) errors.push("Passwords do not match.");

		if (errors.length) {
			setErrors(errors);
			showError(errors[0]);
			return;
		}

		try {
			setErrors();
			showSpinner(submitBtn, "Creating account...");

			const res = await http.post("/auth/register", {
				name: fullName,
				email,
				password,
				phone,
				role: "candidate", // or "applicant" based on backend
				metadata: { skills },
			});

			const message = res?.message || "Account created. Please check your email to confirm.";
			showSuccess(message);
			form.reset();
			setTimeout(() => (window.location.href = "/app/pages/login.html"), 1200);
		} catch (err) {
			console.error("❌ API error", err);
			const serverErrors = Array.isArray(err?.data?.errors) ? err.data.errors.map((e) => e.message || String(e)) : [];
			const message = serverErrors[0] || err?.message || "Unable to create account.";
			setErrors(serverErrors.length ? serverErrors : [message]);
			showError(message);
		} finally {
			hideSpinner(submitBtn);
		}
	});
}
